module.exports = __webpack_public_path__ + "static/media/DV.b4ff442f.webp";